// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__1Lr9B","gradient":"styles_gradient__TQmh-"};